<mat-toolbar fxLayoutAlign="space-between center" color="primary">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="50px">
    <a routerLink="/" class="logo"></a>
    <div fxShow="true" fxHide.lt-sm="true" fxLayoutGap="15px" class="header__navigation">
       <!-- <a mat-button color="primary" routerLink="home">{{ 'HOME' | translate }}</a>
       <a mat-button color="primary" routerLink="saved-calculations">{{ 'SAVED_CALCULATIONS' | translate }}</a> -->
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-around center">
    <!-- tperetzke - 2025-11-27: This feature is temporarily disabled - read comment at the end of this document
    <spx-icon-button
      fxShow="true"
      fxHide.lt-sm="true"
      [type]="'mat-icon-button'"
      [iconName]="'apps'"
      (click)="onShowApps()"
      (click)="$event.stopPropagation()">
    </spx-icon-button>
    -->
    <mat-menu #languageMenu="matMenu">
      <button mat-menu-item (click)="changeLanguage(language)" *ngFor="let language of supportedLangs" class="language-switch__language-selection">
        <div fxLayout="row" fxLayoutAlign="center center">
          <img class="language-selection__image" src="assets/img/flags/{{ language }}.svg" alt="Language {{ language }}" />
          <span>{{ getLanguageName(language) | async }}</span>
        </div>
      </button>
    </mat-menu>
    <button mat-button [matMenuTriggerFor]="languageMenu" class="header__language-switch">
      <img class="language-switch__current-language" src="assets/img/flags/{{ currentLang }}.svg" alt="Current Language" />
    </button>
    <mat-menu #appMenu="matMenu">
      <div [disabled]="false" fxHide="false" fxShow.lt-sm="true" mat-menu-item>{{ name }}</div>
      <button fxHide="false" fxShow.lt-sm="true" type="button" mat-menu-item routerLink="calculation"><mat-icon>home</mat-icon>{{ 'HOME' | translate }}</button>
      <button fxHide="false" fxShow.lt-sm="true" type="button" mat-menu-item routerLink="saved-calculations">
        <mat-icon>folder_special</mat-icon>{{ 'SAVED_CALCULATIONS' | translate }}
      </button>
      <mat-divider fxHide="true" fxShow.lt-sm="true"></mat-divider>
      <button type="button" mat-menu-item (click)="showInfo()"><mat-icon>info</mat-icon>{{ 'APP_INFO' | translate }}</button>
      <button type="button" mat-menu-item (click)="changePassword()"><mat-icon>account_circle</mat-icon>{{ 'CHNG_PASS' | translate }}</button>
      <button type="button" mat-menu-item (click)="logout()"><mat-icon>power_settings_new</mat-icon>{{ 'LOGOUT' | translate }}</button>
    </mat-menu>
    <p class="header__identity-name" fxShow="true" fxHide.lt-sm="true">
      {{ name }}
    </p>
    <spx-icon-button fxShow="true" fxHide.lt-sm="true" [type]="'mat-icon-button'" [iconName]="'keyboard_arrow_down'" [matMenuTriggerFor]="appMenu"></spx-icon-button>
    <spx-icon-button fxHide="true" fxShow.lt-sm="true" [type]="'mat-icon-button'" [iconName]="'menu'" [matMenuTriggerFor]="appMenu"></spx-icon-button>
  </div>
</mat-toolbar>

<!-- tperetzke - 2025-11-27:

   Feature temporarily disabled due to new browser warnings regarding missing "Local Network Access permission"
   (introduced in Chrome 142 / portal is affected because it operates on local network resources which are ending
   on '.local' like 'portal-api.seepex.local' / see https://developer.chrome.com/blog/local-network-access)

<div
  [ngStyle]="{
    display: showApps ? 'block' : 'none'
  }"
  style="height: 400px; width: 400px; position: absolute; top: 6%; right: 4%; z-index: 1000">
  <mat-card style="height: 100%">
    <mat-card-content style="height: 100%">
      <iframe
        class="portal-iframe"
        [src]="appDrawerUrl | safe"
        height="100%"
        width="100%"></iframe>
    </mat-card-content>
  </mat-card>
</div>
-->